module.exports = __webpack_public_path__ + "img/DNARepair-LICA_GSE236681.5263863e.png";